import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { useNav } from "hooks/useNav";
import { useStyles } from "../styles";
import { ReportShort } from "types/ShiftTracker";
import { DateTime } from "luxon";
import CustomIconButton from "componentsNew/buttons/CustomIconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { ModalWindow } from "componentsNew/modals/ModalWindow";
import {
  DeleteShiftModalContent,
  ReportCommentModalContent,
} from "componentsNew/modals/modalContent/ShiftModelContent";
import { openModal } from "actions/modalActions";
import { DISPATCHER, SUPERVISOR } from "constants/constants";

interface ShiftrReportsRowProps {
  row: ReportShort;
  userRole: number;
}

export const ShiftrReportsRow: FC<ShiftrReportsRowProps> = ({ row, userRole }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const { viewReport } = useNav();

  const handleClick = (event: any) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenModal = (modalName: string) => {
    handleClose();
    dispatch(openModal(modalName));
  };

  const returnFormatedTime = (value: string) => {
    return DateTime.fromISO(String(value) || "").toFormat("dd-MM-yyyy");
  };

  return (
    <TableRow>
      <TableCell className={classes.tableCell}>
        <Typography>{Number(row.week_number) + 1}</Typography>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Typography>{row.get_week_day}</Typography>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Typography className={classes.editButton} onClick={() => viewReport(row.id)}>
          {returnFormatedTime(row.report_date)}
        </Typography>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Typography>{row.station.title}</Typography>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Typography>
          {row.created_by?.first_name} {row.created_by?.last_name}
        </Typography>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Typography>{returnFormatedTime(String(row.created).split("T0")[0])}</Typography>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Typography>
          {row.edited_by?.first_name} {row.edited_by?.last_name}
        </Typography>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Typography>{returnFormatedTime(String(row.modified).split("T0")[0])}</Typography>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <CustomIconButton
          icon={<MoreVertIcon />}
          iconColor={"darkGray"}
          theme={"blank"}
          action={handleClick}
        />
        <Menu
          id="login-menu"
          anchorEl={anchorEl}
          elevation={0}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={() => handleOpenModal(`shift-comment-modal-${row.id}`)}>
            <ListItemIcon>
              <CommentOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Comment</ListItemText>
          </MenuItem>
          {![DISPATCHER, SUPERVISOR].includes(userRole) ? (
            <MenuItem
              className="deleteMenuItem"
              onClick={() => handleOpenModal(`shift-delete-modal-${row.id}`)}
            >
              <ListItemIcon>
                <DeleteOutlineOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Delete</ListItemText>
            </MenuItem>
          ) : (
            ""
          )}
        </Menu>
        <ModalWindow
          modal_name={`shift-comment-modal-${row.id}`}
          buttonType={"none"}
          modalTitle={"Comment"}
        >
          <ReportCommentModalContent
            reportId={row.id}
            commentText={row.report_comment}
            handleClose={handleClose}
          />
        </ModalWindow>
        <ModalWindow
          modal_name={`shift-delete-modal-${row.id}`}
          buttonType={"none"}
          theme={"red"}
          modalTitle={"Attention! This action will delete this shift forever."}
          modalDescription={`Are you sure you want to delete the shift report for ${
            row.station.title
          } on ${returnFormatedTime(row.report_date)}?`}
        >
          <DeleteShiftModalContent reportId={row.id} handleClose={handleClose} />
        </ModalWindow>
      </TableCell>
    </TableRow>
  );
};
